import * as React from 'react'

import { Button } from '~/client/src/shared/components/Button/Button'
import { FilePicker } from '~/client/src/shared/components/FilePicker'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { cn } from '~/client/src/shared/utils/cn'
import { toast } from '~/client/src/shared/utils/toast'

interface IProps {
  spacingClassName: string
  acceptPattern: string
  isMultiple: boolean
  icon: React.ReactNode
  label: string
  uploadFile(file: File): Promise<void>
}

export default function PermitFormFileUploadButton({
  spacingClassName,
  acceptPattern,
  isMultiple,
  icon,
  label,
  uploadFile,
}: IProps): JSX.Element {
  const uploadFiles = async (files: File[]): Promise<void> => {
    for (const file of files) {
      try {
        await uploadFile(file)
      } catch {
        toast.error(Localization.translator.uploadFailed)
      }
    }
  }

  return (
    <FilePicker
      accept={acceptPattern}
      multiple={isMultiple}
      onPick={uploadFiles}
      data-testid="permit-file-upload-button"
      render={
        <Button
          variant="outline"
          className={cn('tw:w-full', spacingClassName)}
        />
      }
    >
      {icon}
      {label}
    </FilePicker>
  )
}
